var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(153, 0, 204)",
    d: "M12 0c-1.094 0-2 .906-2 2v2H4c-.523 0-1.055.191-1.43.57C2.191 4.945 2 5.477 2 6v40c0 .523.191 1.055.57 1.434.375.375.907.566 1.43.566h42c.523 0 1.055-.191 1.434-.566.375-.38.566-.91.566-1.434V6c0-.523-.191-1.055-.566-1.43-.38-.379-.91-.57-1.434-.57h-6V2c0-1.094-.906-2-2-2h-2c-1.094 0-2 .906-2 2v2H16V2c0-1.094-.906-2-2-2Zm0 2h2v6h-2Zm24 0h2v6h-2ZM4 6h6v2c0 1.094.906 2 2 2h2c1.094 0 2-.906 2-2V6h18v2c0 1.094.906 2 2 2h2c1.094 0 2-.906 2-2V6h6v7H4Zm0 9h42v31H4Zm6 4v23h30V19Zm2 2h5v5h-5Zm7 0h5v5h-5Zm7 0h5v5h-5Zm7 0h5v5h-5Zm-21 7h5v5h-5Zm7 0h5v5h-5Zm7 0h5v5h-5Zm7 0h5v5h-5Zm-21 7h5v5h-5Zm7 0h5v5h-5Zm7 0h5v5h-5Zm7 0h5v5h-5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.fce40b59cc2c764a949204e3e25aa4ca.svg";
export { ForwardRef as ReactComponent };